import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

import LoginPage from "./pages/LoginPage";
import DashboardLayout from "./layout/DashboardLayout";
import Home from "./pages/Home";
import Mailboxes from "./pages/Mailboxes";
import Tenants from "./pages/Tenants";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          {/* Protected dashboard */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute requiredRole="admin">
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            {/* nested pages */}
            <Route index element={<Home />} />
            <Route path="mailboxes" element={<Mailboxes />} />
            <Route path="tenants" element={<Tenants />} />
          </Route>

          <Route path="*" element={<LoginPage />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}